import { StepButton, StepButtonProps, StepLabel } from '@mui/material';
import { createLink } from '@tanstack/react-router';
import { BrightyStepIcon } from './BrightyStepIcon';

export function BrightyStepButton({ children, ...props }: StepButtonProps) {
  return (
    <StepButton {...props}>
      <StepLabel
        slots={{
          stepIcon: BrightyStepIcon,
        }}
      >
        {children}
      </StepLabel>
    </StepButton>
  );
}
export const BrightyStepButtonLink = createLink(BrightyStepButton);
